/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useIsOnline_user = {
    readonly presence: {
        readonly recentOnlineDate: string | null;
    } | null;
    readonly " $refType": "useIsOnline_user";
};
export type useIsOnline_user$data = useIsOnline_user;
export type useIsOnline_user$key = {
    readonly " $data"?: useIsOnline_user$data;
    readonly " $fragmentRefs": FragmentRefs<"useIsOnline_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIsOnline_user"
};
(node as any).hash = '4d007e83edf5b5cac661d69ef7147655';
export default node;
